import React from "react";

export default function FileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
    >
      <path
        fill="currentColor"
        d="M21.5 6.75V21C21.5 22.6569 20.1569 24 18.5 24H6.5C4.84315 24 3.5 22.6569 3.5 21V3C3.5 1.34314 4.84315 0 6.5 0H14.75L21.5 6.75ZM17 6.75C15.7574 6.75 14.75 5.74264 14.75 4.5V1.5H6.5C5.67157 1.5 5 2.17157 5 3V21C5 21.8284 5.67157 22.5 6.5 22.5H18.5C19.3284 22.5 20 21.8284 20 21V6.75H17Z"
      />

    </svg>
  );
}
